<bootstrap-popup  [id]="'controleSecuriteDialog'"  [title]="'Contrôle de sécurité'" [displaySubject]="displaySubject" [modalSize]="'modal-lg'" [windowCloseButton]="true">

		<form role="form" class="form-horizontal" *ngIf="acces">
			<div class="form-group row col-sm-12">
				<div class="col-sm-3">
					<label for="lien" class="control-label">N° accès </label>
				</div>
				<div class="col-sm-9">
					{{ acces.numero }}
				</div>
			</div>
			
			<div class="form-group row col-sm-12">
				<div class="col-sm-3">
					<label for="lien" class="control-label">Rien à signaler </label>
				</div>
				<div class="col-sm-9">
					<input type="checkbox" [(ngModel)]="rienASignaler" (ngModelChange)="rienASignalerChange()" name="rienASignaler"  />
				</div>
			</div>
			
			<div class="form-group row col-sm-12" *ngIf="!rienASignaler">
				<div class="col-sm-3">
					<label for="lien" class="control-label">Contrôle de sécurité </label>
				</div>
				<div class="col-sm-9">
					<select
						name="controleSecurite" id="controleSecurite"
						class="form-control"
						style="width: 18em; display: inline; padding-top: 3px;"
						[(ngModel)]="controleSecurite"
						>
						<option [ngValue]="null">&nbsp;</option>
						<option *ngFor="let option of (controlesSecurite$ | async)" [ngValue]="option.id">{{ option.label }}</option>
					</select>
				</div>
			</div>
			
	 		<div class="row">
				<div class="col-md-12">
					<div class="form-group text-center">
						<button type="button" class="btn btn-success" style="margin-right: 10px" (click)="annuler()">
							Annuler
						</button>
						<button type="button" class="btn btn-primary" style="margin-right: 6px" (click)="autoriser()">
							Autoriser
						</button>
					</div>
				</div>
			</div>
		</form>
</bootstrap-popup>